import { Action } from "redux";
import { EmailEditorConfig, SystemEmailTemplate } from "model/SystemEmailTemplate";

// ---------------------------------------------------------------------------
// Action type constants
// ---------------------------------------------------------------------------
export const SYSTEM_EMAIL_TEMPLATES_RESET_ACTION_TYPE                = "SYSTEM_EMAIL_TEMPLATES_RESET";
export const SYSTEM_EMAIL_TEMPLATES_FETCH_LIST_START_ACTION_TYPE     = "SYSTEM_EMAIL_TEMPLATES_FETCH_LIST_START";
export const SYSTEM_EMAIL_TEMPLATES_FETCH_LIST_SUCCESS_ACTION_TYPE   = "SYSTEM_EMAIL_TEMPLATES_FETCH_LIST_SUCCESS";
export const SYSTEM_EMAIL_TEMPLATES_FETCH_TEMPLATE_START_ACTION_TYPE   = "SYSTEM_EMAIL_TEMPLATES_FETCH_TEMPLATE_START";
export const SYSTEM_EMAIL_TEMPLATES_FETCH_TEMPLATE_SUCCESS_ACTION_TYPE = "SYSTEM_EMAIL_TEMPLATES_FETCH_TEMPLATE_SUCCESS";
export const SYSTEM_EMAIL_TEMPLATES_FETCH_CONFIG_START_ACTION_TYPE     = "SYSTEM_EMAIL_TEMPLATES_FETCH_CONFIG_START";
export const SYSTEM_EMAIL_TEMPLATES_FETCH_CONFIG_SUCCESS_ACTION_TYPE   = "SYSTEM_EMAIL_TEMPLATES_FETCH_CONFIG_SUCCESS";
export const SYSTEM_EMAIL_TEMPLATES_SAVE_START_ACTION_TYPE             = "SYSTEM_EMAIL_TEMPLATES_SAVE_START";
export const SYSTEM_EMAIL_TEMPLATES_SAVE_SUCCESS_ACTION_TYPE           = "SYSTEM_EMAIL_TEMPLATES_SAVE_SUCCESS";
export const SYSTEM_EMAIL_TEMPLATES_ERROR_ACTION_TYPE                  = "SYSTEM_EMAIL_TEMPLATES_ERROR";

// ---------------------------------------------------------------------------
// Action interfaces
// ---------------------------------------------------------------------------
interface SystemEmailTemplatesResetAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_RESET_ACTION_TYPE> {}

interface SystemEmailTemplatesFetchListStartAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_FETCH_LIST_START_ACTION_TYPE> {}

interface SystemEmailTemplatesFetchListSuccessAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_FETCH_LIST_SUCCESS_ACTION_TYPE> {
  payload: { list: Array<SystemEmailTemplate> };
}

interface SystemEmailTemplatesFetchTemplateStartAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_FETCH_TEMPLATE_START_ACTION_TYPE> {}

interface SystemEmailTemplatesFetchTemplateSuccessAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_FETCH_TEMPLATE_SUCCESS_ACTION_TYPE> {
  payload: { template: SystemEmailTemplate };
}

interface SystemEmailTemplatesFetchConfigStartAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_FETCH_CONFIG_START_ACTION_TYPE> {}

interface SystemEmailTemplatesFetchConfigSuccessAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_FETCH_CONFIG_SUCCESS_ACTION_TYPE> {
  payload: { config: EmailEditorConfig };
}

interface SystemEmailTemplatesSaveStartAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_SAVE_START_ACTION_TYPE> {}

interface SystemEmailTemplatesSaveSuccessAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_SAVE_SUCCESS_ACTION_TYPE> {
  payload: { template: SystemEmailTemplate };
}

interface SystemEmailTemplatesErrorAction
  extends Action<typeof SYSTEM_EMAIL_TEMPLATES_ERROR_ACTION_TYPE> {}

export type SystemEmailTemplatesAction =
  | SystemEmailTemplatesResetAction
  | SystemEmailTemplatesFetchListStartAction
  | SystemEmailTemplatesFetchListSuccessAction
  | SystemEmailTemplatesFetchTemplateStartAction
  | SystemEmailTemplatesFetchTemplateSuccessAction
  | SystemEmailTemplatesFetchConfigStartAction
  | SystemEmailTemplatesFetchConfigSuccessAction
  | SystemEmailTemplatesSaveStartAction
  | SystemEmailTemplatesSaveSuccessAction
  | SystemEmailTemplatesErrorAction;
